/**
 * One question asked before the app signs the user out: "may I?". Whoever holds something a
 * sign-out would break (a live phone call) registers it; `useAuth().signOut` asks it first.
 */
type Guard = () => boolean | Promise<boolean>;

let guard: Guard | null = null;

export const setBeforeSignOut = (next: Guard | null): void => {
  guard = next;
};

/** The user said no: nothing was signed out. Callers treat it like any failed sign-out. */
export class SignOutCancelledError extends Error {
  constructor() {
    super('Sign out cancelled');
    this.name = 'SignOutCancelledError';
  }
}

/** Throws `SignOutCancelledError` when the registered guard says no. */
export async function askBeforeSignOut(): Promise<void> {
  if (guard && !(await guard())) throw new SignOutCancelledError();
}
